import React, { useState, useEffect } from "react";
import { useUser } from "../../../../hooks/useUser";
import { ReactComponent as TankerCrudeIcon } from "../../../../Assets/NewIconsForCards/TankerCrudeIcon.svg";
import { ReactComponent as TruckScaleIcon } from "../../../../Assets/NewIconsForCards/TruckScaleIcon.svg";
import Card from "../../../Components/Card";

export default function WXScaleStationHome(props) {
  const [newCards, setNewCards] = useState([]);
  const [_user, ,] = useUser();

  useEffect(() => {
    let newCardArray = CardsArray.filter((card) => {
      //the find method returns the whole value based on true or false
      let foundRole = card.roles.find((role) => {
        //loop at each card roles, then check if role is in user role, return boolean from includes
        let foundinUserRoles = _user.roles.includes(role);
        //This is boolean is for find on line above
        return foundinUserRoles;
      });

      if (foundRole) {
        return card;
      }
    });

    setNewCards(newCardArray);
  }, []);

  const CardsArray = [
    {
      title: "Crude Order",
      text: "",
      Icon: TankerCrudeIcon,
      link: "/TerminalActivity/StartWithCrudeOrder",
      roles: ["Admin", "SuperAdmin", "Loader"],
    },
    {
      title: "Scale State",
      text: "",
      Icon: TruckScaleIcon,
      link: "/TerminalActivity/WXScaleState",
      roles: ["Admin", "SuperAdmin"],
    },
  ];

  return (
    <div className="container-fluid ">
      <div className="mainContainer">
        <div className="overviewCardContainer">
          {newCards.map((record, i) => (
            <Card {...record} key={i} />
          ))}
        </div>
      </div>
    </div>
  );
}
